import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Handles the Emergent OAuth callback: reads session_id from URL fragment,
 * exchanges it via backend, and redirects to dashboard.
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                if (data?.session_token) {
                    localStorage.setItem("session_token", data.session_token);
                }
                setUser(data.user);
                // Strip hash and go to dashboard
                window.history.replaceState({}, "", "/");
                navigate("/", { replace: true, state: { user: data.user } });
            } catch (e) {
                console.error("Auth exchange failed", e);
                const msg = e?.response?.status === 403
                    ? (e.response.data?.detail || "Access denied — this Google account isn't authorised.")
                    : "Sign-in failed. Please try again.";
                navigate("/login", { replace: true, state: { error: msg } });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen bg-[#faf7ef] flex items-center justify-center" data-testid="auth-callback-loading">
            <div className="text-stone-500 text-sm uppercase tracking-widest">Signing you in…</div>
        </div>
    );
}
